module.exports = __webpack_public_path__ + "static/media/QRCode_Dark.09049c65.svg";